<template>
  <tr :class="{'last-month-row': isLastMonthOrOver, 'archived-row': rollOut.archived_at }">
    <th>
      <a :href="`/storage/${rollOut.logo_path}`" data-lity v-if="rollOut.logo_thumb_path">
        <img :src="`/storage/${rollOut.logo_thumb_path}`" style="width: 100px; max-height: 100px;">
      </a>
    </th>
    <th scope="row">{{ rollOut.country.name }}</th>
    <td>
      <i class="fa fa-trash-alt" v-if="rollOut.distributor && rollOut.distributor.deleted_at"></i>
      <a href="#" @click.prevent="$emit('showDistributorModal', rollOut.distributor)" v-if="rollOut.distributor">{{ rollOut.distributor.company_name }}</a>
    </td>
    <td>{{ rollOut.key_account ? rollOut.key_account.name : '' }}</td>
    <td>{{ rollOut.start_date | date }}</td>
    <td>{{ rollOut.test_period }}</td>
    <td>{{ rollOut.stores }}</td>
    <td>{{ rollOut.formattedEquipmentsName }}</td>
    <td class="text-right">{{ avgSmallPrinters }}</td>
    <td class="text-right">{{ avgLargePrinters }}</td>
    <td>{{ rollOut.user.name }}</td>
    <td class="text-right nowrap">
      <button type="button" class="btn btn-danger btn-sm"
        @click="$emit('showGalleryModal', rollOut)"
        style="margin-left: 16px;"
      >
        <i class="fa fa-images"></i>
      </button>
      <a :href="`/roll_outs/${rollOut.id}`" class="btn btn-sm btn-warning">
        <i class="fa fa-list-alt"></i>
      </a>
      <a :href="`/roll_outs/${rollOut.id}/burn_rates`" class="btn btn-sm btn-primary"><i class="fa fa-fire"></i></a>
      <template v-if="isAdmin || rollOut.user_id === authUserId">
        <button type="button" class="btn btn-secondary btn-sm"
          @click="$emit('deleteRollOut', rollOut)"
          style="margin-left: 16px"
        >
          <i class="fa fa-trash-alt"></i>
        </button>
      </template>
    </td>
  </tr>
</template>

<script>
  import { date } from './../../filters'
  import moment from 'moment'
  import avgBurnRateMixin from './../trials/avg-burnrate-mixin'

  export default {
    mixins: [avgBurnRateMixin],
    props: ['rollOut'],
    data() {
      return {
        authUserId: window.authUserId,
        isAdmin: window.isAdmin,
      }
    },
    filters: {
      date,
    },
    computed: {
      isLastMonthOrOver() {
        const endsAt = moment(this.rollOut.start_date).add(this.rollOut.test_period, 'months').startOf('month')
        return moment().isSameOrAfter(endsAt)
      },
      getModel() {
        return this.rollOut
      },
    }
  }
</script>

<style scoped>
  tbody td, tbody th {
    vertical-align: middle
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/roll_outs/RollOut.vue